// extracted by mini-css-extract-plugin
module.exports = {"tab_container":"SettingsPage__tab_container___TKY-1","button_row":"SettingsPage__button_row___9WzzO"};